import Webcam from "react-webcam"
import React, { useState } from 'react';
import "../../../Styles/Webcam.css";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';

const WebcamRender = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [recordingMessage, setrecordingMessage] = useState('');
    const [isCameraActive, setIsCameraActive] = useState(false);

    return (
        <div className="webcam-container">
            <div className="webcam-wrapper">
                {!isCameraActive && (
                    <div className="webcam-placeholder">
                        {errorMessage ? <VideocamOffIcon sx={{ fontSize: 40, color: 'rgba(255,255,255,0.5)' }} /> : <CameraAltIcon sx={{ fontSize: 40, color: 'rgba(255,255,255,0.5)' }} />}
                    </div>
                )}
                <Webcam
                    className={`webcam-real ${isCameraActive ? 'active' : 'hidden'}`}
                    mirrored
                    onUserMedia={() => {
                        setrecordingMessage("REC");
                        setIsCameraActive(true);
                    }}
                    onUserMediaError={(error) => {
                        console.error("Webcam Error:", error);
                        setIsCameraActive(false);
                        if (error.name === 'NotAllowedError' || error.message === 'Permission denied') {
                            setErrorMessage('יש לתת הרשאות למצלמה');
                        } else {
                            setErrorMessage('לא נמצאה מצלמה זמינה, וודאו שהיא מחוברת');
                        }
                    }}
                />
                {isCameraActive && recordingMessage && (
                    <p className="recording-message">🔴</p>
                )}
            </div>
            {errorMessage && (
                <div className="error-toast">
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default WebcamRender;
